import { render, staticRenderFns } from "./Detail-Contact.vue?vue&type=template&id=55bd1b5c"
import script from "./Detail-Contact.vue?vue&type=script&lang=js"
export * from "./Detail-Contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports